import * as React from 'react';
import styles from './styles.module.styl';
export var BetaBadge = function () { return React.createElement("span", { className: "badge badge-warning ".concat(styles.badge) }, "Beta"); };
